import { type ReactNode } from 'react'
import { Table, TableBody, TableHead, TableHeader } from '@/components/Table'
import styles from './InventoryTable.module.css'
import {
  type ColumnId,
  type InventoryColumnDetails,
} from '@/features/inventory/admin/inventory-table-columns'

/**
 * Maps column names to their respective styles.
 */
const inventoryTableColumnStyles: Record<ColumnId, string> = {
  ServiceItem: styles.titleColumn,
  Global: styles.globalColumn,
  Hidden: styles.hiddenColumn,
  LastUpdatedBy: styles.lastUpdatedColumn,
  ServiceType: styles.serviceTypeColumn,
  Version: styles.numberColumn,
  VersionCreated: styles.lastUpdatedColumn,
  Courtesy: styles.numberColumn,
  PriceType: styles.typeColumn,
  SupportingItems: styles.supportingItemsColumn,
  Price: styles.pricingColumn,
  ProPrice: styles.pricingColumn,
  Actions: styles.actionsColumn,
}

export interface InventoryTableProps {
  columns: InventoryColumnDetails[]
  /**
   * The infinite scroll loader, rendered below the table while more items can be fetched.
   */
  loader?: ReactNode
  children?: ReactNode
}

export function InventoryTable({
  columns,
  loader,
  children,
}: InventoryTableProps) {
  return (
    <>
      <Table striped>
        <TableHead>
          {columns.map((col) => (
            <TableHeader
              className={inventoryTableColumnStyles[col.id]}
              align={col.align}
              key={col.id}
            >
              {col.header}
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
      {loader}
    </>
  )
}
